module.exports = __webpack_public_path__ + "static/image/company/pc/image_program.ver2_0_2.jpg?71608b2a";